<script setup lang="ts">
import { ActionFields } from '~/components/cms/Action/actionHelpers'
import { cardTransformer, CardFields } from './cardHelpers'

export type SixUpCardPanelProps = {
  cards: CardFields[]
  references?: [
    {
      fields: {
        action: ActionFields
        title?: string
        tagline?: string
      }
    },
  ]
}

const props = defineProps<SixUpCardPanelProps>()
const reference = props?.references?.[0]?.fields
const title = reference?.title
const action = reference?.action
const tagline = reference?.tagline
</script>

<template>
  <section class="sixup-panel" data-testid="sixup-panel">
    <div class="container-custom">
      <div class="sixup-panel__header">
        <p class="sixup-panel__tagline">{{ tagline }}</p>
        <h3 class="sixup-panel__title heading-2" v-if="title" v-html="title"></h3>
        <Action v-if="action" data-testid="sixup-panel__action" v-bind="action" />
      </div>
      <div class="sixup-panel__cards">
        <Card v-for="card in cards.slice(0, 6)" v-bind="cardTransformer(card)" variant="six-up" preset="six-up" />
      </div>
    </div>
  </section>
</template>

<style lang="postcss">
.sixup-panel {
  margin-bottom: var(--component-space);

  .container-custom {
    margin: 0 auto;
    padding-inline: var(--space-100);
    @media (--tablet) {
      padding-inline: 8rem; /* 128px */
    }
    @media (--desktop) {
      max-width: var(--container-max-width); /* 1280px */
      padding-inline: 1rem;
    }
  }

  .sixup-panel__header {
    text-align: center;
  }

  .sixup-panel__tagline {
    font-size: var(--text-small);
    font-weight: bold;
    letter-spacing: var(--letter-spacing-2);
    text-transform: uppercase;
    margin-bottom: var(--space-30);
  }

  .sixup-panel__title {
    margin-bottom: var(--space-70);
  }

  .sixup-panel__cards {
    width: 100%;
    margin-top: var(--space-90);
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-50) var(--space-20);
    overflow: hidden;

    @media (--tablet) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (--desktop) {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }
  }
}
</style>
.
